import { BillableStateType } from "./model";
export function isBillable(billableState) {
  return billableState.type === BillableStateType.Billable;
}
export function nonBillableReason(billableState) {
  return isBillable(billableState) ? null : billableState.nonBillable.reason;
}